"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faFolderOpen_1 = require("@fortawesome/free-solid-svg-icons/faFolderOpen");
const InterviewSummary_1 = __importDefault(require("../validations/InterviewSummary"));
const SurveyAdmin_1 = require("../../../actions/SurveyAdmin");
const Survey_1 = require("../../../actions/Survey");
const InterviewListComponent_1 = __importDefault(require("../validations/InterviewListComponent"));
const ReviewPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const interview = (0, react_redux_1.useSelector)((state) => state.survey.interview);
    const [showInterviewList, setShowInterviewList] = (0, react_1.useState)(true);
    const [prevInterviewUuid, setPrevInterviewUuid] = (0, react_1.useState)(undefined);
    const [nextInterviewUuid, setNextInterviewUuid] = (0, react_1.useState)(undefined);
    const handleInterviewSummaryChange = (0, react_1.useCallback)((interviewUuid, prevUuid, nextUuid) => {
        if (interviewUuid) {
            // If prev/next UUIDs are provided (called from list), use them directly
            if (prevUuid !== undefined || nextUuid !== undefined) {
                setPrevInterviewUuid(prevUuid || undefined);
                setNextInterviewUuid(nextUuid || undefined);
            }
            else {
                // If no prev/next UUIDs provided (called from navigation buttons),
                // try to extract them from the DOM as fallback
                const listButton = document.getElementById(`interviewButtonList_${interviewUuid}`);
                if (listButton) {
                    const domPrevUuid = listButton.getAttribute('data-prev-uuid');
                    const domNextUuid = listButton.getAttribute('data-next-uuid');
                    setPrevInterviewUuid(domPrevUuid === null || domPrevUuid === '' ? undefined : domPrevUuid);
                    setNextInterviewUuid(domNextUuid === null || domNextUuid === '' ? undefined : domNextUuid);
                }
                else {
                    // If DOM element not found, clear the navigation
                    setPrevInterviewUuid(undefined);
                    setNextInterviewUuid(undefined);
                }
            }
            dispatch((0, SurveyAdmin_1.startFetchCorrectedInterviewAndAudits)(interviewUuid));
        }
        else {
            // Close button clicked - clear the interview and show the list
            setShowInterviewList(true);
            setPrevInterviewUuid(undefined);
            setNextInterviewUuid(undefined);
            // Clear the current interview from Redux state
            dispatch((0, Survey_1.setInterviewState)(undefined));
        }
    }, [dispatch]);
    const handleInterviewListChange = (0, react_1.useCallback)((show) => {
        setShowInterviewList(show);
    }, []);
    return (react_1.default.createElement("div", { className: "survey" },
        react_1.default.createElement("div", { className: "admin" },
            react_1.default.createElement("div", { style: { flexDirection: 'row', flex: '1 1 auto' } },
                interview && !showInterviewList && (react_1.default.createElement("div", { style: { float: 'right', position: 'relative', left: '-3rem' } },
                    react_1.default.createElement("button", { title: t('admin:ShowInterviewList'), onClick: () => handleInterviewListChange(true) },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faFolderOpen_1.faFolderOpen }),
                        ' '))),
                interview && (react_1.default.createElement(InterviewSummary_1.default, { key: interview.uuid, handleInterviewSummaryChange: handleInterviewSummaryChange, prevInterviewUuid: prevInterviewUuid, nextInterviewUuid: nextInterviewUuid }))),
            react_1.default.createElement(InterviewListComponent_1.default, { onInterviewSummaryChanged: handleInterviewSummaryChange, initialSortBy: [{ id: 'response.accessCode' }], interviewListChange: handleInterviewListChange, showInterviewList: showInterviewList, validationInterview: interview }))));
};
exports.default = ReviewPage;
//# sourceMappingURL=ReviewPage.js.map